import {api} from "./api";
import {MODERATOR_COURSE_LESSON_RESOURCE} from "../mock/URLs";

export const createResource = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_COURSE_LESSON_RESOURCE, formData)
    return data;
  } catch (e) {
    throw e
  }
}

export const getResources = async (lessonId: string) => {
  try {
    const {data} = await api.get(`${MODERATOR_COURSE_LESSON_RESOURCE}?lesson=${lessonId}`, {
      params: {
        page_size: Infinity
      }
    })
    return data;
  } catch (e) {
    throw e
  }
}

export const getResourceById = async (resourceId: number) => {
  try {
    const {data} = await api.get(`${MODERATOR_COURSE_LESSON_RESOURCE}${resourceId}/`)
    return data.data;
  } catch (e) {
    throw e
  }
}

export const updateResource = async (resourceId: number, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_COURSE_LESSON_RESOURCE}${resourceId}/`, formData)
    return data;
  } catch (e) {
    throw e
  }
}
